import { Layout } from 'components'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { createNewUser, getPositionData } from 'service/AdminService'
import {
    postRegisterUser,
    setPositionById,
} from 'store/slices/AdminSlice'
import Notification from 'utils/Notifications'
import styles from './RegisterForm.module.scss'
import { ScaleLoader } from 'react-spinners'
import { useEffect } from 'react'
import { getCurrentDate } from 'utils/todayDateForInput'
const RegisterForm = () => {
  //UserInfo
  const [loader, setLoader] = useState(false)


  const [gender, setGender] = useState(null)
  const [first_name, setFirst_name] = useState('')
  const [last_name, setLast_name] = useState('')
  const [middle_name, setMiddle_name] = useState('')
  const [data_of_birth, setData_of_birth] = useState('')
  const [number_phone, setNumber_phone] = useState('')
  const [email, setEmail] = useState('')


  const [inn, setInn] = useState(null)
  //Passport


  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })
  const dispatch = useDispatch()
  const getData = async () => {
    let data
    try {
      let response = await getPositionData(data)

      dispatch(
        setPositionById({
          position: response.data,
        }),
      )
    } catch (error) {
      console.log("CHU")
    }
  }

  useEffect(() => {
    getData()
  }, [])
  //Const & Let
  const handleSubmit = async (event) => {
    event.preventDefault()
    if (
      gender === null ||
      first_name === null ||
      last_name === null ||
      middle_name  === null ||
      data_of_birth === null ||
      number_phone === null ||
      email === null ||
      inn === null
    ) {
      setNotify({
        isOpen: true,
        message: 'Заполните все поля!',
        type: 'warning',
        sound: 'warning',
      })
    } else
      try {
        setLoader(true)
        const password = inn
        let response = await createNewUser(
          gender,
          first_name,
          last_name,
          middle_name,
          data_of_birth,
          number_phone,
          email,
          inn,
          password,
        )
        dispatch(
          postRegisterUser({
            gender,
            first_name,
            last_name,
            middle_name,
            data_of_birth,
            number_phone,
            email,
            inn,
            password,
          }),
        )
        setNotify({
          isOpen: true,
          message: 'Пользователь успешно добавлен!',
          type: 'success',
          sound: 'success',
        })
        await new Promise((resolve) => setTimeout(resolve, 2000))
        window.location.reload()
      } catch (error) {
        console.log("CHU")

        setNotify({
          isOpen: true,
          message: 'Ошибка!',
          type: 'error',
          sound: 'error',
        })
      }finally {
        setLoader(false)
      }
  }

  //Consts & Let

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.title}>Регистрация пользователя</div>
        <form action="#">
          <span className={styles.gender_title}>Выберите пол </span>
          <div className={styles.gender_details}>
            <div style={{ display: 'flex' }}>
              <input
                style={{
                  height: '18px',
                  width: '18px',
                  background: '#d9d9d9',
                  borderRadius: '50%',
                  marginRight: '10px',
                  border: '5px solid transparent',
                }}
                type="radio"
                name="gender"
                id="dot-1"
                value={gender}
                onChange={(e) => setGender('Мужчина')}
                required
              />
              <span className={styles.gender}>Мужчина</span>
            </div>
            <div style={{ display: 'flex' }}>
              <input
                style={{
                  height: '18px',
                  width: '18px',
                  background: '#d9d9d9',
                  borderRadius: '50%',
                  marginRight: '10px',
                  border: '5px solid transparent',
                }}
                type="radio"
                name="gender"
                id="dot-2"
                value={gender}
                onChange={(e) => setGender('Женщина')}
                required
              />
              <span className={styles.gender}>Женщина</span>
            </div>
          </div>

          <div className={styles.user_details}>
          <div className={styles.input_pox}>
              <span className={styles.datails}>Фамилия</span>
              <input
                type="text"
                placeholder="Введите фамилию"
                value={last_name}
                onChange={(e) => setLast_name(e.target.value)}
                required
              />
            </div>
            <div className={styles.input_pox}>
              <span className={styles.datails}>Имя</span>
              <input
                type="text"
                placeholder="Введите полное имя"
                value={first_name}
                onChange={(e) => setFirst_name(e.target.value)}
                required
              />
            </div>
           
            <div className={styles.input_pox}>
              <span className={styles.datails}>Отчество</span>
              <input
                type="text"
                placeholder="Введите Отчество"
                value={middle_name}
                onChange={(e) => setMiddle_name(e.target.value)}
                required
              />
            </div>
            <div className={styles.input_pox}>
              <span className={styles.datails}>Дата рождения</span>
              <input
                type="date"
                placeholder="Введите дату рождения"
                value={data_of_birth}
                max={getCurrentDate()}
                onChange={(e) => setData_of_birth(e.target.value)}
                required
              />
            </div>
            <div className={styles.input_pox}>
              <span className={styles.datails}>Номер телефона</span>
              <input
                type="text"
                placeholder="Введите номер телефона"
                value={number_phone}
                onChange={(e) => {
                  const value = e.target.value;
                  // Проверяем, является ли введенное значение числом
                  if (!isNaN(value)) {
                    // Если число, обновляем состояние
                    setNumber_phone(value);}
                  }}
                required
              />
            </div>
            <div className={styles.input_pox}>
              <span className={styles.datails}>E-mail</span>
              <input
                type="email"
                placeholder="Введите электронную почту"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

           
            <div className={styles.input_pox}>
              <span className={styles.datails}>ИНН</span>
              <input
                type="text"
                placeholder="Введите ИНН"
                value={inn}
                
                  onChange={(e) => {
                    const value = e.target.value;
                    // Проверяем, является ли введенное значение числом
                    if (!isNaN(value)) {
                      // Если число, обновляем состояние
                      setInn(value);}
                    }}
                required
              />
            </div>
            
            
           
        
          </div>
          {loader ? (
            <ScaleLoader color="black" size={30} />
          ) : (
            <div className={styles.button}>
            <input
              type="submit"
              onClick={handleSubmit}
              value="Добавить в команду"
            />
          </div>
          )}
          
        </form>
      </div>
      <Notification notify={notify} setNotify={setNotify} />
    </Layout>
  )
}

export default RegisterForm
